<template>
  <div class="pa-5 w-100">
    <p class="text-h6 primary--text">
      Titularidade do ingresso
    </p>

    <p>
      <strong class="ellipsis nome-produto-plano">{{ ingresso.product_name }}</strong>
      <strong> - </strong>
      <strong class="ellipsis nome-produto-plano">{{ ingresso.plan_name }}</strong>
    </p>

    <p>
      Atenção! Após cadastrar a titularidade do ingresso, só é permitido edita-la
      <strong>uma única vez</strong>.
    </p>

    <hr v-if="desktop">

    <v-form @submit.prevent="enviaDados">
      <v-row class="mt-5">
        <v-col class="py-0">
          <v-text-field
            v-model.trim="form.name"
            label="*Nome"
            filled
            background-color="white"
            class="mt-2"
            hide-details="auto"
            :error-messages="getErrorMessage('name')"
            @change="$v.form.name.$touch()"
          />
        </v-col>

        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            v-model="form.cnpjCpf"
            v-mask="'###.###.###-##'"
            label="*CPF"
            filled
            background-color="white"
            class="mt-2"
            hide-details="auto"
            :error-messages="getErrorMessage('cnpjCpf')"
            @change="$v.form.cnpjCpf.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            v-model.trim="form.email"
            label="E-mail"
            filled
            background-color="white"
            class="mt-2"
            hide-details="auto"
            :error-messages="getErrorMessage('email')"
            @change="$v.form.email.$touch()"
          />
        </v-col>

        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            v-model="form.phone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            label="Telefone"
            filled
            background-color="white"
            class="mt-2"
            hide-details="auto"
            :error-messages="getErrorMessage('phone')"
            @change="$v.form.phone.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            v-model.trim="form.position"
            label="Cargo"
            filled
            background-color="white"
            class="mt-2"
            hide-details="auto"
          />
        </v-col>

        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            v-model.trim="form.company"
            label="Empresa"
            filled
            background-color="white"
            class="mt-2"
            hide-details="auto"
          />
        </v-col>
      </v-row>

      <hr v-if="desktop" class="mt-5">

      <div class="text-right pt-5">
        <v-btn type="submit" color="primary" :block="mobile">
          Salvar dados
        </v-btn>
        <v-btn
          v-if="mobile"
          class="mt-2"
          color="primary"
          text
          block
          @click="$emit('cancel')"
        >
          <v-icon>mdi-chevron-left</v-icon> Voltar
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { required, email } from 'vuelidate/lib/validators';
import { cpf } from 'cpf-cnpj-validator';
import validaNomeComSobrenome from '@/utils/validacoes/validaNomeComSobrenome';

const errorMessages = {
  name: 'Por favor, preencha o campo com o nome completo.',
  cnpjCpf: 'Por favor, digite um CPF válido.',
  email: 'Por favor, digite um e-mail válido.',
  phone: 'Por favor, digite um telefone válido.',
};

export default {
  name: 'TitularidadeIngressoForm',

  directives: { mask },

  props: {
    ingresso: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    form: {},
  }),

  watch: {
    ingresso() {
      this.preencheForm();

      this.$v.form.$reset();
    },
  },

  created() {
    this.preencheForm();
  },

  methods: {
    preencheForm() {
      this.form = {
        ...this.ingresso,
        cnpjCpf: this.ingresso.cnpj_cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'),
        phone: this.ingresso.phone.replace('+55 ', ''),
      };
    },

    enviaDados() {
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.$emit('submit', this.form);
      }
    },

    getErrorMessage(field) {
      const vField = this.$v.form[field];

      if (vField.$dirty && vField.$invalid) {
        return [errorMessages[field]];
      }

      return [];
    },
  },

  validations: () => ({
    form: {
      name: {
        required,
        possuiSobrenome: validaNomeComSobrenome,
      },
      cnpjCpf: {
        required,
        cpfCnpj: value => cpf.isValid(value),
      },
      email: {
        email,
      },
      phone: {
        telefoneBrasil: value => !value || value.length > 13,
      },
    },
  }),
};
</script>

<style scoped>
  .nome-produto-plano {
    max-width: 260px;
  }
</style>
